import { BASE_URL,  JOB } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IJob, IJobInput } from "models/job";


export async function getJobs(params: string = ""):Promise<IJob[] > {
  const response = await axios.get(BASE_URL + JOB + params);
  return response.data;
}
export async function addJob(data: IJobInput) {
  const response = await axios.post(BASE_URL + JOB, data);
  return response.data;
}
export async function editJob(data: IJobInput, id: string) {
  const response = await axios.patch(BASE_URL + JOB + "/" + id, data);
  return response.data;
}

export async function deleteJob(id: string) {
  const response = await axios.delete(BASE_URL + JOB + "/" + id);
  return response.data;
}

export const JobsCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },

  {
    id: "titleAr",
    numeric: false,
    disablePadding: false,
    label: "T_title_Ar",
  },

  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
